import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    unitStockLocations: [],
  },

  getters: {
    unitStockLocations(state) {
      return state.unitStockLocations
    },
  },

  mutations: {
    SET_UNIT_STOCK_LOCATIONS(state, value) {
      state.unitStockLocations = value
    },
  },

  actions: {
    loadUnitStockLocations({ commit }, unitId) {
      return axios.get(`api/units/${unitId}/stock-locations`).then((response) => {
        commit('SET_UNIT_STOCK_LOCATIONS', response.data.data)
        return response.data.data
      })
    },
    storeStockChanges({ commit }, { unitId, stocks }) {
      return axios.post(`api/units/${unitId}/stock-changes`, { stocks }).then((response) => {
        commit('SET_UNIT_STOCK_LOCATIONS', response.data.data)
        return response.data
      })
    },
    loadStockChangeHistory({ commit }, { stockLocationId, params = {} }) {
      return axios.get(`api/stock-locations/${stockLocationId}/stock-changes`, { params })
        .then((response) => response.data)
    },
  },
}
